module.exports = __webpack_public_path__ + "static/media/books.cae1a28c.svg";